define('services/auth/info',['require','exports','module'],function (require, exports, module) {
  'use strict';

  var authInfo,
    init = function (data) {
      authInfo = {};
      authInfo.access_token = data.access_token;
      authInfo.expires_in = data.expires_in; // seconds
      authInfo.user_name = data.user_name;
      authInfo.group_id = data.group_id;
      authInfo.rol_id = data.rol_id;
      authInfo.user_id = data.user_id;
      authInfo.company_id = data.company_id;
      authInfo.company_name = data.company_name;
      authInfo.companies = data.companies;
      authInfo.companiesByGroup = data.companiesByGroup;
      authInfo.creation_time = new Date().getTime(); // ms
    },
    now = function () {
      return new Date().getTime();
    },
    LOCAL_STORAGE_KEY = 'authInfo';

  module.exports = function (localStorage) {
    localStorage = localStorage || window.localStorage;
    return {
      localStorageKey: LOCAL_STORAGE_KEY,
      get: function () {
        return authInfo;
      },
      init: function (data) {
        init(data);
      },
      initFromLocalStorage: function () {
        authInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
      },
      clear: function () {
        authInfo = {};
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      },
      save: function () {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(authInfo));
      },
      getAccessToken: function () {
        return authInfo.access_token ? authInfo.access_token : '';
      },
      getUserName: function () {
        return authInfo.user_name ? authInfo.user_name : '';
      },
      getRolId: function () {
        return authInfo.rol_id ? authInfo.rol_id : '';
      },
      getUserId: function () {
        return authInfo.user_id ? authInfo.user_id : '';
      },
      getGroupId: function () {
        return authInfo.group_id ? authInfo.group_id : '';
      },
      getCompanyId: function () {
        return authInfo.company_id ? authInfo.company_id : '';
      },
      getCompanyName: function () {
        return authInfo.company_name ? authInfo.company_name : '';
      },
      getCompanies: function () {
        return authInfo.companies ? authInfo.companies : [];
      },
      getCreationTime: function () {
        return authInfo.creation_time;
      },
      getExpirationTime: function () {
        return authInfo.creation_time + authInfo.expires_in * 1000;
      },
      isExpired: function () {
        return now() >= this.getExpirationTime();
      },
      isValid: function () {
        return authInfo && authInfo.access_token && !this.isExpired();
      },
      getTimeToExpire: function () {
        return this.getExpirationTime() - now();
      },
      expiresInLessThan: function (ms) {
        var timeToExpire = this.getTimeToExpire();
        return timeToExpire > 0 && ms >= timeToExpire;
      },
      isSuperAdmin: function () {
        return (
          authInfo &&
          (authInfo.rol_id === 'admin_mdirector' || authInfo.rol_id === 'admin_mdirector_sa')
        );
      },
      isAdminFreemium: function () {
        return authInfo && authInfo.rol_id === 'adm_mdirector_newfree';
      },
      isAdmin: function () {
        return authInfo && authInfo.rol_id === 'adm_mdirector';
      },
      isAdm: function () {
        return this.isAdmin() || this.isAdminFreemium();
      },
      getGroupCompanies: function () {
        return authInfo.companiesByGroup ? authInfo.companiesByGroup : [];
      },
    };
  };
});

